
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden } from "../../reducers/uiReducer";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, regular, light, thin, duotone, brands } from "@fortawesome/fontawesome-svg-core/import.macro";

const TimeDateList: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const getCurrentTime = () => {
        const currentDate = new Date();
        return currentDate.toLocaleTimeString('en-US', {
            hour: 'numeric', // Show hour (1-12 or 0-23)
            minute: '2-digit', // Show minutes (always 2 digits)
            hour12: true, // Use 12-hour format (true) or 24-hour format (false)
        });
    };
    const getCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toLocaleDateString('en-US', { 
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        });
    };
    

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "fit-content",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                //backgroundColor: "orange",
                fontSize: "1.5vh",
                padding: "1vh 0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textAlign: "center",
            }}
        >

            <div
                style={{
                    height: "100%",
                    width: "auto",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    verticalAlign: "middle",
                    textAlign: "center",
                    gap: "1vh",
                }}

            >
                <FontAwesomeIcon 
                    icon={regular('clock')} 
                    style={{ 
                        width: '2.25vh', 
                        height: '2.25vh',
                        color: `rgb(${uiData.schemeColor})`,
                    }}
                /> 

                {getCurrentTime()}
            </div>

            <div
                style={{
                    height: "100%",
                    width: "auto",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    verticalAlign: "middle",
                    textAlign: "center",
                    gap: "1vh",
                }}

            >
                <FontAwesomeIcon 
                    icon={regular('calendar-lines')} 
                    style={{ 
                        width: '2.25vh', 
                        height: '2.25vh',
                        color: `rgb(${uiData.schemeColor})`,
                    }}
                /> 

                {getCurrentDate()}

            </div>

            <div
                style={{
                    height: "100%",
                    width: "auto",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    //verticalAlign: "middle",
                    textAlign: "center",
                    gap: "1vh",
                }}

            >
                <FontAwesomeIcon 
                    icon={regular('map-location-dot')} 
                    style={{ 
                        width: '2.25vh', 
                        height: '2.25vh',
                        color: `rgb(${uiData.schemeColor})`,
                    }}
                /> 

                <span 
                    style={{ 
                        verticalAlign: 'middle', 
                        lineHeight: '2vh' 
                    }}
                > 
                    {hardmoneyData.propertyLocation}
                </span>
            </div>

            <div
                style={{
                    height: "100%",
                    width: "auto",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    verticalAlign: "middle",
                    textAlign: "center",
                    gap: "1vh",
                }}

            >
                <FontAwesomeIcon 
                    icon={regular('map')} 
                    style={{ 
                        width: '2.25vh', 
                        height: '2.25vh',
                        color: `rgb(${uiData.schemeColor})`,
                    }}
                /> 
                <span 
                    style={{ 
                        verticalAlign: 'middle', 
                        lineHeight: '2vh' 
                    }}
                > 
                    {hardmoneyData.propertyType}
                </span>
            </div>

        </div>
    );
};

export default TimeDateList;
